export const GAME_TYPES_CONFIG = {
    'Bingo90': {
        id: 'Bingo90',
        name: 'Bingo90',
        displayName: 'Binfun 90',
        mode: 'classic',
        maxNumbers: 90,
        gridSize: 15,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: null,
        winImage: '/images/award/bingo_90.png',
        allowedInAccounts: true,
        playerDisplayCells: 15,
        historic: 'GameHistoric',
        numbersGrid: 'NumbersGrid'
    },
    'Bingo75': {
        id: 'Bingo75',
        name: 'Bingo75',
        displayName: 'Binfun 75',
        mode: 'classic',
        maxNumbers: 75,
        gridSize: 24,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: null,
        winImage: '/images/award/bingo_75.png',
        allowedInAccounts: true,
        playerDisplayCells: 24,
        historic: 'GameHistoric',
        numbersGrid: 'NumbersGrid'
    },
    'BingoMex': {
        id: 'BingoMex',
        name: 'BingoMex',
        displayName: 'Lotería mexicana',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/mex_cards_small.webp',
        winImage: '/images/award/bingo_mex.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'BingoAnimals': {
        id: 'BingoAnimals',
        name: 'BingoAnimals',
        displayName: 'Binfun animales',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/animal_cards.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'BingoCartoon': {
        id: 'BingoCartoon',
        name: 'BingoCartoon',
        displayName: 'Binfun caricaturas',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cartoon_cards.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'Movies': {
        id: 'Movies',
        name: 'Movies',
        displayName: 'Binfun películas',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/movies_cards.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'MoviesKids': {
        id: 'MoviesKids',
        name: 'MoviesKids',
        displayName: 'Binfun películas kids',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/kid_movies_cards.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'XMas': {
        id: 'XMas',
        name: 'XMas',
        displayName: 'X-Mas',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_xmas.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'Football': {
        id: 'Football',
        name: 'Football',
        displayName: 'Football',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_football.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'Halloween': {
        id: 'Halloween',
        name: 'Halloween',
        displayName: 'Halloween',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_halloween.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'Superheroes': {
        id: 'Superheroes',
        name: 'Superheroes',
        displayName: 'Superheroes',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_superheroes.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'Cartoon': {
        id: 'Cartoon',
        name: 'Cartoon',
        displayName: 'Binfun Cartoon',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_superheroes_cartoon.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'Music': {
        id: 'Music',
        name: 'Music',
        displayName: 'Binfun Music',
        mode: 'sound',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/cards_music.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'Canary': {
        id: 'Canary',
        name: 'Canary',
        displayName: 'Binfun Canary Islands',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_canary.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'MusicReggaeton': {
        id: 'MusicReggaeton',
        name: 'MusicReggaeton',
        displayName: 'Binfun Music Reggaeton',
        mode: 'sound',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/cards_music_reggaeton.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'BingoDominicano': {
        id: 'BingoDominicano',
        name: 'BingoDominicano',
        displayName: 'Lotería dominicana',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards-bingo-dominicano.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'BingoIberostar': {
        id: 'BingoIberostar',
        name: 'BingoIberostar',
        displayName: 'Bingo Iberostar',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards-iberostar.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'MusicWinterEnglish': {
        id: 'MusicWinterEnglish',
        name: 'MusicWinterEnglish',
        displayName: 'Binfun Music Winter English',
        mode: 'sound',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/cards_music_winter_english.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'MusicWinterSpanglish': {
        id: 'MusicWinterSpanglish',
        name: 'MusicWinterSpanglish',
        displayName: 'Binfun Music Winter Spanglish',
        mode: 'sound',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/cards_music_winter_spanglish.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'BingoGloriaMusicos': {
        id: 'BingoGloriaMusicos',
        name: 'BingoGloriaMusicos',
        displayName: 'Bingo Gloria Musicos',
        mode: 'cards',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/BINGO-GLORIA-MUSICOS_V1.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'BingoGloriaLuchadores': {
        id: 'BingoGloriaLuchadores',
        name: 'BingoGloriaLuchadores',
        displayName: 'Bingo Gloria Luchadores',
        mode: 'cards',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/BINGO-GLORIA-LUCHADORES_V1.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'BingoGloriaChavo': {
        id: 'BingoGloriaChavo',
        name: 'BingoGloriaChavo',
        displayName: 'Bingo Gloria Chavo',
        mode: 'cards',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/BINGO-GLORIA-CHAVO_V1.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'BingoGloriaActors': {
        id: 'BingoGloriaActors',
        name: 'BingoGloriaActors',
        displayName: 'Bingo Gloria Actors',
        mode: 'cards',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/BINGO-GLORIA-ACTORES_V1.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'CalamarGame': {
        id: 'CalamarGame',
        name: 'CalamarGame',
        displayName: 'Calamar Game',
        mode: 'sound',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/juego_calamar.jpg',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'CalamarIcons': {
        id: 'CalamarIcons',
        name: 'CalamarIcons',
        displayName: 'Calamar Icons',
        mode: 'sound',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/calamar_icons.jpg',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'SquidGames': {
        id: 'SquidGames',
        name: 'SquidGames',
        displayName: 'Squid Games',
        mode: 'sound',
        maxNumbers: 24,
        gridSize: 9,
        numberWidth: 6,
        numberHeight: 4,
        cardImage: '/images/cards/cards_squid_games.webp',
        winImage: '/images/award/binfun.png',
        allowedInAccounts: true,
        playerDisplayCells: 9,
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    },
    'BingoFifa26': {
        id: 'BingoFifa26',
        name: 'BingoFifa26',
        displayName: 'Selecciones FIFA 26',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_fifa_26.webp',
        winImage: '/images/award/bingo_mex.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    'BingoJugadoresFifa26': {
        id: 'BingoJugadoresFifa26',
        name: 'BingoJugadoresFifa26',
        displayName: 'Jugadores FIFA 26',
        mode: 'cards',
        maxNumbers: 54,
        gridSize: 16,
        numberWidth: 9,
        numberHeight: 6,
        cardImage: '/images/cards/cards_jugadores_fifa_26.webp',
        winImage: '/images/award/bingo_mex.png',
        allowedInAccounts: true,
        playerDisplayCells: 16,
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
};
